<script>
    import { onMount, onDestroy } from 'svelte';
    import {Link, navigate} from "svelte-routing";
    import {_} from '../lib/i18n';

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';
    export let analyzes = [];

    onMount(() => {
        if (analyzes.length === 0) {
            if (localStorage.getItem('ru_spy_tariff_selected')) {
                navigate(`${path}/dashboard/subscription`);
                return;
            }
            if (localStorage.getItem('lastAccountInfo')) {
                const landingAccount = JSON.parse(localStorage.getItem('lastAccountInfo'));

                if (params.addAnalyze instanceof Function) {
                    params.addAnalyze(
                        true,
                        landingAccount.username,
                        landingAccount.instagram_id,
                        landingAccount.username,
                        null,
                        landingAccount.photo,
                        null,
                        null,
                        null
                    );
                }
                navigate(`${path}/dashboard/analyze/${landingAccount.username}`);
                return;
            } else {
                navigate(`${path}/dashboard/add-account`);
                return;
            }
        } else {
            navigate(`${path}/dashboard/analyze/${analyzes[0].id}`);
            return;
        }


        //window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: $_('home.pageTitle'),
                    pageTitleTag: $_('home.pageTitleTag'),
                });
            }
        } catch (err) {
            console.error(err);
        }
    });

    onDestroy(() => {

    });



</script>

<div class="" >

</div>

<style>

</style>